<template>
    <div class="grid gap-1" :class="[required ? 'grid-cols-10' : 'grid-cols-12']">
        <label
            class="py-1 text-center transition-colors border-2 border-solid rounded border-dark cursor-pointer"
            :class="{ 'col-span-2': i === 1 && !required, 'active': isActive(i) }"
            v-for="i in (required ? 10 : 11)"
            :key="i"
        >
            <input type="radio" class="hidden" v-model="proxyValue" :value="getValueForStep(i)">

            {{ getDisplayValueForStep(i) }}
        </label>
    </div>
</template>
<script>
export default {
    props: {
        modelValue: [String, Number],
        required: Boolean
    },
    computed: {
        proxyValue: {
            get() {
                return this.modelValue;
            },
            set(val) {
                this.$emit("update:modelValue", val);
            }
        }
    },
    methods: {
        getValueForStep(count) {
            if (!this.required) {
                return count === 1 ? null : (count - 1);
            }

            return count;
        },
        getDisplayValueForStep(count) {
            if (!this.required) {
                return count === 1 ? "N/A" : (count - 1);
            }

            return count;
        },
        isActive(count) {
            return this.proxyValue === this.getValueForStep(count);
        },
    },
};
</script>

<style scoped>
.active {
    @apply bg-primary text-white;
}
</style>
